import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotifyService {
  public title: string = 'Alert';
  public message: string = '';
  public messageType: string = '';
  public show: boolean = false;

  public Notify(title: string, message: string, messageType: string,time:number=3000) {
    this.show = true;
    this.title = title;
    this.message = message;
    this.messageType = messageType;
    setTimeout(() => {
      this.show = false;
    }, time);
  }
}
